
export default function Paginations({
  current,
  totalPages,
  onChange,
  classNamePaginations
}) {
  const getPages = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Trang đầu
    pages.push(1);

    // current = 1,2,3
    if (current <= 3) {
      pages.push(2, 3, 4);
      pages.push("end-ellipsis");
      pages.push(totalPages);
      return pages;
    }

    // current gần cuối
    if (current >= totalPages - 2) {
      pages.push("start-ellipsis");
      pages.push(totalPages - 3);
      pages.push(totalPages - 2);
      pages.push(totalPages - 1);
      pages.push(totalPages);
      return pages;
    }

    // current ở giữa
    pages.push("start-ellipsis");
    pages.push(current - 1);
    pages.push(current);
    pages.push(current + 1);
    pages.push("end-ellipsis");
    pages.push(totalPages);

    return pages;
  };

  const pages = getPages();

  return (
    <div className={`flex items-center justify-between p-5 ${classNamePaginations}`}>
      <button
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="cursor-pointer disabled:opacity-40"
      >
        <svg width="35" height="35"viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
      </button>

      <div className="flex items-center gap-3 text-[#CA8504] font-semibold">
        {pages.map((item, index) =>
          typeof item === "number" ? (
            <button
              key={item}
              onClick={() => onChange(item)}
              className={`flex h-12 w-12 items-center justify-center rounded-md text-[20px] transition font-semibold
            ${item === current
                  ? "bg-[#FEFBE8] text-[#713B12] shadow"
                  : "hover:text-[#7B5125]"
                }`}
            >
              {item}
            </button>
          ) : (
            <span key={`${item}-${index}`}>...</span>
          )
        )}
      </div>

      <button
        disabled={current === totalPages}
        onClick={() => onChange(current + 1)}
        className="cursor-pointer disabled:opacity-40"
      >
        <svg width="35" height="35" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
      </button>
    </div>
  );
}